import styled from "styled-components";

export const StyledUnorderedListInt = styled.ul<{
  equalLabelWidth?: boolean;
}>`
  list-style-type: none;
  padding-left: 0;
  max-width: 100%;
  padding-bottom: 10px;

  ${props =>
    props.equalLabelWidth &&
    `
  display: table;
  & > li {
    display: table-row;
    & > * {
      display: table-cell;
      &:first-of-type {
        padding-right: 8px;
      }
    }
  }
  `}
`;

export const StyledPagesLandingPageListItem = styled.li`
  list-style-type: none;
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
`;

export const StyledUnorderedListHeader = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
  font-weight: 500;
  color: #000;
  margin-top: 8px;
`;

export interface StyledUnorderedListProps {
  children?: React.ReactNode;
  equalLabelWidth?: boolean;
}
export const StyledUnorderedList = ({
  children,
  equalLabelWidth
}: StyledUnorderedListProps) => {
  return (
    <StyledUnorderedListInt equalLabelWidth={equalLabelWidth}>
      {children}
    </StyledUnorderedListInt>
  );
};
